import { defineStore } from 'pinia';
import { reactive, ref, Ref } from 'vue';
import _ from 'lodash';
import type { PaazlDeliveryOptionsRequestObject } from '@/types/Paazl/PaazlDeliveryOptionsRequestObject.ts';
import { PaazlGetShippingOptionsRequest } from '@/communication/Magento/Paazl/PaazlGetShippingOptionsRequest.ts';
import type { PaazlShippingOption } from '@/types/Paazl/PaazlShippingOption.ts';

export const usePaazlStore = defineStore(`paazl-${window.store_code}`, () => {
  const deliveryOptionsRequest = reactive(new PaazlGetShippingOptionsRequest());
  const deliveryOptions: Ref<PaazlShippingOption[]> = ref([]);

  async function requestShippingOptions(
    data: PaazlDeliveryOptionsRequestObject
  ): Promise<void> {
    const deliveryOptionsResponse = (
      await deliveryOptionsRequest
        .setSku(data.sku)
        .setShippingCutoffTime(data.shipping_cutoff_time ?? undefined)
        .setProcessingDays(data.processing_days ?? undefined)
        .setWidth(data.width)
        .setHeight(data.height)
        .setPaazlDeliveryMatrix(data.paazl_delivery_matrix ?? undefined)
        .setProductPrice(data.product_price)
        .getResponse()
    ).data as PaazlShippingOption[];

    // Get the delivery options and sort them by date
    deliveryOptions.value = _.orderBy(
      deliveryOptionsResponse,
      ['date.deliveryDate'],
      ['desc']
    );
  }

  return {
    deliveryOptionsRequest,
    deliveryOptions,
    requestShippingOptions,
  };
});
